<template>
  <div class="career-list-item">
    <div class="flex flex-row justify-between career-list-item__row">
      <div class="career-list-item__row--header">
        {{ node.name }}
      </div>
      <div class="flex flex-row">
        Is this current?
        <toggle-button
          v-model="node.current"
          :sync="true"
          :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"
          class="margin-x-2"
          :labels="{ checked: 'YES', unchecked: 'NO' }"
          @input="(value) => { $emit('toggleRetired', node, value) }"/>
        <div class="delete-button">
          <i class="fa fa-times" @click="() => { $emit('delete', node) }"></i>
        </div>
      </div>
    </div>
    <div class="flex flex-row career-list-item__row career-list-item__row--highlight">
      <div class="flex flex-row" v-if="!node.pending">
        <div class="flex" v-for="ancestor in node.ancestors" :key="ancestor.id">
          <div>
            {{ ancestor.name }}
          </div>
          <div class="spacer-x-2">></div>
        </div>
        {{ node.name }}
      </div>
      <div v-else>
        Under review
      </div>
      <div class="flex flex-row" v-if="node.has_children">
        <div class="spacer-x-2">></div>
        <button class="add-tag-button" v-if="!searching" @click="startSearching"><i class="fa fa-pencil"></i> Add tag</button>

        <tag-picker
          v-if="searching"
          :input-id="'search' + node.id"
          :current="current"
          placeholder="Search"
          :full-width="false"
          :parent-node="node.id"
          :maximum="6"
          :can-add="false"
          @selected="(option) => { $emit('selected', option, node.id) }"/>
      </div>
    </div>
  </div>
</template>

<script>
import TagPicker from '../misc/TagPicker'
export default {
  components: { TagPicker },
  props: {
    node: {
      type: Object,
      required: true
    },
    current: {
      type: Array,
      required: true
    }
  },

  methods: {
    startSearching () {
      this.searching = true
      setTimeout(() => {
        document.getElementById('search' + this.node.id).focus()
      }, 100)
    }
  },

  data () {
    return {
      searching: false
    }
  }
}
</script>

<style scoped lang="scss">
.add-tag-button {
  border: none;
  background: none;
  color: var(--brand-primary);
  text-decoration: underline;
}
</style>
